import React, { Ref } from 'react';
import IconBase, { IconProps } from '../IconBase';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const IconHangerLarge = (baseProps: IconProps, svgRef?: Ref<SVGSVGElement>) => (
  <IconBase {...baseProps}>
    {({
      title,
      titleId,
      ...props
    }: React.SVGProps<SVGSVGElement> & SVGRProps) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        color="currentColor"
        aria-hidden="true"
        ref={svgRef}
        aria-labelledby={titleId}
        {...props}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M20.5 15.5L31.7304 23.8007C31.9 23.9261 32 24.1244 32 24.3353C32 24.7024 31.7024 25 31.3353 25H2.66168C2.29624 25 2 24.7038 2 24.3383C2 24.1259 2.10203 23.9263 2.27427 23.8019L16 13.5C17.3016 12.55998 20 10.5 20 8.44344C20 6.5 18.9717 5 17 5C15.3431 5 14 7.34315 14 8V8.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </IconBase>
);
const IconHangerLargeWithRef = React.forwardRef(IconHangerLarge);

IconHangerLargeWithRef.displayName = 'IconHangerLarge';

export default IconHangerLargeWithRef;
